export default __webpack_public_path__ + "static/28-01-03e4d258fe3bfd06db3211d35db075c9.jpg";